<mat-toolbar class="header">
  <!-- <span class="example-spacer"></span> -->
  <button (click)="goTo('home')">
    <img class="logo" src="../../assets/images/MySembraTeal.svg" alt="SembraCare Logo" />
  </button>
  <span class="example-spacer"></span>

  <div style="display: flex;justify-content: space-between;align-items: center;">
    <button *ngIf="isLoggedIn" (click)="addNotificationComponent()">
      <!-- <mat-icon>notifications</mat-icon> -->
      <!-- <mat-icon class="unread-notification" *ngIf="hasUnreadNotification()">circle</mat-icon> -->
      <i class="fa-solid fa-bell" style="color: #0000c2;" *ngIf="!hasUnreadNotification()"></i>
       <i class="fa-solid fa-bell-exclamation" style="color: #f44336;" *ngIf="hasUnreadNotification()"></i>
    </button>

    <div *ngIf="agencyCodeList.length > 1 && isShowAgency">
      <mat-form-field class="agency-list">
        <mat-select id="ac" #ac="ngModel" [(ngModel)]="selectedAgencyCode" name="acs" placeholder="AgencyCode"
          (selectionChange)="onAgencyCodeChange($event.value)">
          <mat-option *ngFor="let ac of agencyCodeList" [value]="ac">
            {{ ac }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <div *ngIf="isUserAuthenticated(); else publicNav">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="goTo('home')">
          <span>
            {{ "HOME.TITLE" | translate }}
            <mat-spinner *ngIf="showLoader" [diameter]="20"></mat-spinner>
          </span>
        </button>
        <button mat-menu-item (click)="goTo('profile')">
          <span>{{ "HOME.PROFILE" | translate }}</span>
        </button>
        <!-- <button mat-menu-item (click)="goTo('threads-priority')">
          <span>{{ "HOME.THREADS_PRIORITY" | translate }}</span>
        </button>
        <button mat-menu-item (click)="goTo('threads-category')">
          <span>{{ "HOME.THREADS_CATEGORY" | translate }}</span>
        </button>
        <button mat-menu-item (click)="goTo('threads-status')">
          <span>{{ "HOME.THREADS_STATUS" | translate }}</span>
        </button> -->
        <button mat-menu-item (click)="goTo('feedback')">
          <span>{{ "HOME.FEEDBACK" | translate }}</span>
        </button>
        <button mat-menu-item (click)="openUserGuide()">
          <mat-icon>help_outline</mat-icon>
          <span>Help</span>
        </button>
        <button mat-menu-item (click)="logOut()">
          <span>{{ "HOME.LOGOUT" | translate }}</span>
        </button>
      </mat-menu>
    </div>

    <ng-template #publicNav>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>menu</mat-icon>
      </button>
      <mat-menu #menu="matMenu" #publicNav>
        <button mat-menu-item (click)="goTo('login')">
          <span>{{ "LOGIN.TITLE" | translate }}</span>
        </button>

        <!-- <button mat-menu-item (click)="goTo('resend-code')">
          <span>{{ "LOGIN.VERIFY_ACCOUNT" | translate }}</span>
        </button> -->

        <!-- <button mat-menu-item (click)="goTo('signup')">
          <span>{{ "SIGNUP.TITLE" | translate }}</span>
        </button> -->
      </mat-menu>
    </ng-template>
  </div>




</mat-toolbar>

<app-user-guide-dialog
  [isOpen]="showUserGuide"
  (closed)="showUserGuide = false">
</app-user-guide-dialog>